var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "c-desktop-nav", attrs: { role: "navigation" } },
    [
      _vm._l(_vm.mainNav, function(navItem, index) {
        return [
          _c("nav-item", {
            key: "c-desktop-nav__item_" + index,
            ref: "j-desktop-nav__item_" + index,
            refInFor: true,
            staticClass: "c-desktop-nav__item",
            class: {
              "c-desktop-nav__item--no-margin": index === _vm.mainNav.length - 1
            },
            attrs: {
              item: navItem,
              "is-mobile": _vm.isMobile,
              "my-index": index,
              "tabindex-start": _vm.mainNav.length + 1
            }
          })
        ]
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "c-desktop-nav__active-indicator j-desktop-nav__active-position"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }